
export default (t) => [
  {
    text: t('Station Name'),
    value: 'name',
    sortable: false,
    togglable: true
  },
  {
    text: t('Branch'),
    value: 'branch',
    sortable: false,
    width: 160,
    togglable: true
  },
  {
    text: t('Categories'),
    value: 'categories',
    sortable: false,
    togglable: true
  },
  {
    text: t('Status'),
    value: 'is_active',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 120
  },
];
